import SecurityEventsPage from "security-app/components/SecurityEvents/Alerts";
import EventReplaySideBarDetails from "security-app/components/SecurityEvents/ReplaySearch/EventReplaySideBarDetails";
import EventDefinitionSideBarDetails from "security-app/components/SecurityEvents/ReplaySearch/EventDefinitionSideBarDetails";
import useLicenseCheck from "license/useLicenseCheck";
const useValidSecurityLicensePresent = () => {
  const {
    security: { isValid: isValidSecurityLicense }
  } = useLicenseCheck();
  return isValidSecurityLicense;
};
const securityEventsBindings = {
  "views.components.securityEventsPage": [
    {
      component: SecurityEventsPage,
      key: "securityEventsTable"
    }
  ],
  "views.components.eventReplay.sideBarDetails": {
    useCondition: useValidSecurityLicensePresent,
    key: "SecurityEventSideBar",
    component: EventReplaySideBarDetails,
    eventDefinitionComponent: EventDefinitionSideBarDetails
  }
};
export default securityEventsBindings;
